import { Card, Chip, Text, Title } from '@nimbus-ds/components';
import { Stack } from 'commons/components';

function Skeleton(): JSX.Element {
  return (
    <Card>
      <Card.Header>
        <Title.Skeleton as="h4" />
      </Card.Header>
      <Card.Body>
        <Stack column align="stretch">
          <Text.Skeleton width="20%" />
          <Stack align="stretch">
            <Chip.Skeleton width="7%" />
            <Chip.Skeleton width="12%" />
          </Stack>
          <Text.Skeleton width="20%" />
          <Stack align="stretch">
            <Chip.Skeleton width="7%" />
            <Chip.Skeleton width="14%" />
            <Chip.Skeleton width="14%" />
          </Stack>
        </Stack>
      </Card.Body>
    </Card>
  );
}

export default Skeleton;
